module.exports = __webpack_public_path__ + "static/media/q.3f488aad.svg";